import {
  Provider,
  Root,
  Trigger,
  Portal,
  Content,
  Arrow,
} from "@radix-ui/react-tooltip";
import type { ReactNode } from "react";
import { cn } from "../../lib/cn";

export function TooltipProvider({ children }: { children: ReactNode }) {
  return (
    <Provider delayDuration={250} skipDelayDuration={150}>
      {children}
    </Provider>
  );
}

export function Tooltip({
  label,
  children,
  side = "top",
  align = "center",
}: {
  label: ReactNode;
  children: ReactNode;
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
}) {
  return (
    <Root>
      <Trigger asChild>{children}</Trigger>
      <Portal>
        <Content
          side={side}
          align={align}
          sideOffset={6}
          className={cn(
            "z-50 max-w-xs rounded-md border border-neutral-700 bg-neutral-900",
            "px-2 py-1 text-[11px] text-neutral-200 shadow-md",
            "animate-in fade-in zoom-in-95",
          )}
        >
          {label}
          <Arrow className="fill-neutral-900" />
        </Content>
      </Portal>
    </Root>
  );
}
